import config from '@plone/volto/registry';

/**
 * Gets the language code from the URL pathname.
 *
 * It checks the first segment of the path against the list of supported languages.
 * If no supported language is found in the path, it returns the default language.
 *
 * @param pathname The URL pathname (e.g., '/de/some/page').
 * @returns The detected language code (e.g., 'de').
 */
export function getLangFromPath(pathname: string): string {
  const settings = config.settings;
  const supportedLanguages = settings.supportedLanguages || [];
  const defaultLanguage = settings.defaultLanguage || 'de'; // Failsafe default

  if (!settings.isMultilingual || supportedLanguages.length === 0) {
    return defaultLanguage;
  }

  // Get the first segment of the path (e.g., 'de' from '/de/studium')
  const potentialLang = pathname.split('/').filter(Boolean)[0];

  if (potentialLang && supportedLanguages.includes(potentialLang)) {
    return potentialLang;
  }

  return defaultLanguage;
}
